export default __webpack_public_path__ + "../images/apple-touch-icon-180x180.png";